import React, { Component } from 'react';
import { Radio } from 'antd';
import withFieldWrapper from '../../hocs/withFieldWrapper';

class RadioButtons extends Component {
    static defaultProps = {
        options: []
    };

    onChange = e => this.props.onChange(e.target.value);

    render() {
        const { options, input: { value }, size, disabled } = this.props;

        return <Radio.Group
            size={size}
            value={value}
            onChange={this.onChange}
            disabled={disabled}>
            { options.map(option =>
                <Radio.Button key={option.id} value={option.id}>{ option.value }</Radio.Button>
            )}
        </Radio.Group>
    }
}

export default withFieldWrapper(RadioButtons);
